import { LoadingButton } from "@mui/lab";
import styled from "styled-components";
import PropTypes from "prop-types";

const ButtonStyle = styled(LoadingButton)`
  border-radius: 10px;
  height: fit-content;
  width: fit-content;
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 10px;
`;

const ButtonText = styled.div`
  font: normal normal normal 13px/15px Open Sans;
  white-space: nowrap;
  margin-right: 10px;
  margin-left: 10px;
`;

const IconHolder = styled.div`
  font: normal normal normal 25px/22px Open Sans;
  margin-right: 10px;
  margin-left: 10px;
`;

export default function StyledButton({
  variant,
  color,
  iconLeft,
  iconRight,
  label,
  ...props
}) {
  return (
    <ButtonStyle
      variant={variant}
      color={color}
      loadingPosition="end"
      {...props}
      data-testid="StyledButton-test"
    >
      <IconHolder>{iconLeft}</IconHolder>
      <ButtonText>{label || props.children}</ButtonText>
      <IconHolder>{iconRight}</IconHolder>
    </ButtonStyle>
  );
}

StyledButton.propTypes = {
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  color: PropTypes.oneOf(["primary", "secondary", "error"]),
  iconLeft: PropTypes.element,
  iconRight: PropTypes.element,
  label: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

StyledButton.defaultProps = {
  variant: "text",
  color: "primary",
  iconLeft: null,
  iconRight: null,
  label: null,
  onClick: undefined,
  loading: false,
};
